var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarDrama = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Protection-Sand-Bag-Soldier--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Protection Sand Bag Soldier Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12h4.3a0.51 0.51 0 0 0 0.48 -0.36 6.46 6.46 0 0 1 0.89 -1.85 0.51 0.51 0 0 0 0 -0.52 0.5 0.5 0 0 0 -0.41 -0.27H2v-0.75a0.75 0.75 0 0 0 -1.5 0v1.5a0.76 0.76 0 0 0 0.75 0.75h4A2.51 2.51 0 0 0 7.5 12Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 19.5h-3.5a1.75 1.75 0 0 0 0 3.5h3.5a1.75 1.75 0 0 0 0 -3.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 19.5h-3.5a1.75 1.75 0 0 0 0 3.5h3.5a1.75 1.75 0 0 0 0 -3.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.5a5 5 0 0 0 -5 5v0.41a3.27 3.27 0 0 1 1 2.34 3.23 3.23 0 0 1 -0.19 1.08 0.54 0.54 0 0 0 0.06 0.46 0.52 0.52 0 0 0 0.41 0.21h0.47a3.26 3.26 0 0 1 3.25 3.25 3.22 3.22 0 0 1 -1 2.32 0.27 0.27 0 0 0 -0.06 0.27 0.25 0.25 0 0 0 0.24 0.16h4.82a1 1 0 0 0 1 -1v-9.5a5 5 0 0 0 -5 -5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 14.5a1.75 1.75 0 0 0 0 3.5h3.5a1.75 1.75 0 0 0 0 -3.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.05 5.5a0.53 0.53 0 0 0 -0.39 0.18 0.53 0.53 0 0 0 -0.1 0.42 3 3 0 0 0 5.88 0 0.53 0.53 0 0 0 -0.1 -0.42 0.53 0.53 0 0 0 -0.34 -0.18Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4h7a0.49 0.49 0 0 0 0.38 -0.17 0.49 0.49 0 0 0 0.12 -0.4 4 4 0 0 0 -7.92 0 0.49 0.49 0 0 0 0.12 0.4 0.49 0.49 0 0 0 0.3 0.17Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarDrama);
export default ForwardRef;